import { RuleObject } from 'antd/es/form';

import {
  ExternalRedirectFormInputs,
  ExternalRedirectFormValidationSchema,
  ExternalRedirectTargetType,
} from '@/modules/ExternalRedirects';
import { RedirectEndpointEnum, RedirectMatchModeEnum } from '@/modules/Sites';

export const externalRedirectFormValidationSchema: ExternalRedirectFormValidationSchema = {
  siteId: [],
  fromDomainId: [{ type: 'string', required: true, message: 'Оберіть домен-джерело з системи' }],
  sourceType: [{ type: 'enum', enum: [RedirectEndpointEnum.Node, RedirectEndpointEnum.Path], required: true }],
  sourceNodeId: [
    ({ getFieldValue }) => ({
      required: getFieldValue('sourceType') === RedirectEndpointEnum.Node,
      message: 'Оберіть сторінку-джерело',
    }),
  ],
  sourcePath: [
    ({ getFieldValue }) => ({
      required: getFieldValue('sourceType') === RedirectEndpointEnum.Path,
      message: 'Вкажіть шлях-джерело',
    }),
  ],
  toType: [
    {
      type: 'enum',
      enum: [
        ExternalRedirectTargetType.SystemDomain,
        ExternalRedirectTargetType.ExternalDomain,
        ExternalRedirectTargetType.Site,
      ],
      required: true,
      message: 'Оберіть тип цілі',
    },
  ],
  toDomainId: [
    ({ getFieldValue }) => ({
      required: getFieldValue('toType') === ExternalRedirectTargetType.SystemDomain,
      message: 'Оберіть домен-ціль з системи',
    }),
    ({ getFieldValue }): RuleObject => ({
      validator(): Promise<void> {
        const toType = getFieldValue(ExternalRedirectFormInputs.ToType) as ExternalRedirectTargetType;
        const fromDomainId = getFieldValue(ExternalRedirectFormInputs.FromDomainId) as string | undefined;
        const toDomainId = getFieldValue(ExternalRedirectFormInputs.ToDomainId) as string | undefined;

        if (toType === ExternalRedirectTargetType.SystemDomain && toDomainId && toDomainId === fromDomainId) {
          return Promise.reject(new Error('Домен-ціль не може бути таким самим як домен-джерело'));
        }
        return Promise.resolve();
      }
    })
  ],
  toExternalDomain: [
    ({ getFieldValue }) => ({
      required: getFieldValue('toType') === ExternalRedirectTargetType.ExternalDomain,
      message: 'Вкажіть зовнішній домен',
    }),
    {
      pattern: /^(?!:\/\/)([\dA-Za-z-]+\.)+[A-Za-z]{2,}$/,
      message: 'Вкажіть коректний домен (наприклад example.com)',
    },
  ],
  toSiteId: [
    ({ getFieldValue }) => ({
      required: getFieldValue('toType') === ExternalRedirectTargetType.Site,
      message: 'Оберіть сайт-ціль',
    }),
    ({ getFieldValue }): RuleObject => ({
      validator(): Promise<void> {
        const toType = getFieldValue(ExternalRedirectFormInputs.ToType) as ExternalRedirectTargetType;
        const siteId = getFieldValue(ExternalRedirectFormInputs.SiteId) as string | undefined;
        const toSiteId = getFieldValue(ExternalRedirectFormInputs.ToSiteId) as string | undefined;

        if (toType === ExternalRedirectTargetType.Site && toSiteId && toSiteId === siteId) {
          return Promise.reject(new Error('Сайт-ціль не може бути таким самим як сайт-джерело'));
        }
        return Promise.resolve();
      }
    })
  ],
  targetType: [{ type: 'enum', enum: [RedirectEndpointEnum.Node, RedirectEndpointEnum.Path], required: true }],
  targetNodeId: [
    ({ getFieldValue }) => ({
      required: getFieldValue('targetType') === RedirectEndpointEnum.Node,
      message: 'Оберіть цільову сторінку',
    }),
  ],
  targetPath: [
    ({ getFieldValue }) => ({
      required: getFieldValue('targetType') === RedirectEndpointEnum.Path,
      message: 'Вкажіть цільовий шлях',
    }),
  ],
  statusCode: [{ type: 'number', required: true, message: 'Оберіть код редіректу' }],
  matchMode: [{
    type: 'enum', enum: [RedirectMatchModeEnum.Exact, RedirectMatchModeEnum.Nested, RedirectMatchModeEnum.Prefix], required: true
  }],
  forVisitor: [],
  isActive: [{ type: 'boolean', required: true }],
};
